
import { Component, Vue } from 'vue-property-decorator'
import { MutationTypes } from '../store/mutations'

@Component({
	components: {}
})
export default class InfoPanel extends Vue {
	get showHelp() {
		return this.$tStore.state.showOverview
	}

	set showHelp(val) {
		this.$tStore.commit(MutationTypes.SET_SHOW_OVERVIEW, val)
	}

	get futureHide() {
		return !this.$tStore.state.showOverviewOnStart
	}

	set futureHide(val) {
		this.$tStore.commit(MutationTypes.SET_SHOW_OVERVIEW_ON_START, !val)
	}
}
